import { useEffect, useState } from "react";
import { axiosBaseURL } from "../../http";
import { toast } from "react-toastify";
import { requestTypes } from "../../config/request_config";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { BaseContainer } from "../../core/base_container";
import { BtnClsNames, requestBtnStyle } from "../../config/btn_config";
import { NoneFound } from "../../core/none_found";

export const CreateRequest = () => {
    const [types, setTypes] = useState(null)

    useEffect(() => {
        const getTypes = async () => {
            axiosBaseURL.get('request_api/requests/fullfillment_types/').then(function (response) {
                console.log(response.data)
                setTypes(response.data)
            }).catch(function (error) {
               // toast.error('Failed to fetch types applying defaults')
                setTypes(requestTypes)
            });
        };
        getTypes();
    }, []);

    const handleRequestClick = (item) => {
        if (item.type_value === 'emergency_needs') {
            toast.warning(`Call 911 if you need immediate assistance.`)
        }
        axiosBaseURL.post("request_api/requests/create_request/", {request_type:item.type_value})
            .then(function (response) {
                toast.success(`Request for ${item.type} created!`)
            }).catch(function (error) {
                toast.error(`You already have a request for ${item.type}`)
            });
    }


    return (
        <BaseContainer>
                {types === null ? (
                    <Row className="justify-content-center">
                        <Spinner animation="border" role="status" variant="primary" />
                    </Row>
                ) : Array.isArray(types) && types.length > 0 ? (
                    <div style={{marginTop:'3rem'}}>
                        {
                            types.map((type, index) => (
                                <Row style={{marginBottom:'2rem'}} key={index}>
                                    <Col>
                                        <Button
                                            className={BtnClsNames}
                                            style={requestBtnStyle}
                                            onClick={() => handleRequestClick(type)}>
                                            {type.type}
                                        </Button>
                                    </Col>
                                </Row>
                            ))
                        }
                    </div>
                ) : (
                    <Row className="justify-content-center">
                        <NoneFound item_name='Request Types' min_height={'65vh'} />
                    </Row>
                )}
        </BaseContainer>
    )
}